<template>
        <div
          v-if="a.hasPermission('مرفقات المساح من الطبيعة - مرفقات') || a.hasPermission('edit projects')"
          class="required-block required-block-1 mb-1"
        >
          <h6 class="required-block-title ">
            مرفقات المساح من الطبيعة
          </h6>

          <survey-method-selector
            :project-id="a.projectId"
            :current-method-id="a.surveyUploadMethodId"
            embedded
            @updated="a.onSurveyMethodSelectorUpdated"
          />


          <div
            v-if="a.surveyUploadMethodId == 4"
            class="mb-3 p-3 bg-light rounded"
          >
            <div class="d-flex flex-wrap required-block-cards">
              <b-card
                class="media-card mb-1 shadow-sm"
                body-class="p-1 d-flex flex-column align-items-center"
                
              >
                <div class="w-100 text-center ">
                  <div
                    class="file-title font-weight-bold"
                    style="word-break:break-word"
                  >
                    ملف التصحيح
                  </div>
                </div>
                <div class="media-file-details w-100 text-center ">
                  <template v-if="a.getConditionalFile('correction_file_rtk')">
                    <div class="file-meta text-muted small ">
                      {{ (a.getConditionalFile('correction_file_rtk').extension || '').toUpperCase() }} • {{ a.getConditionalFile('correction_file_rtk').human_readable_size }}
                    </div>
                    <div class="file-meta text-muted small ">
                      <br>{{ a.getConditionalFile('correction_file_rtk').uploader ? a.getConditionalFile('correction_file_rtk').uploader.name : '' }}
                    </div>
                    <div class="file-meta text-muted small ">
                      {{ a.getConditionalFile('correction_file_rtk').created_at | formatJalali }}
                    </div>
                  </template>
                  <template v-else>
                    <div class="text-muted small ">
                      غير موجود
                    </div>
                  </template>
                </div>
                <div class="w-100 mt-1">
                  <div class="d-flex align-items-center gap-1">
                    <b-form-file
                      v-model="a.conditionalUploads.correction_file_rtk"
                      :state="Boolean(a.conditionalUploads.correction_file_rtk)"
                      placeholder="اختر ملف"
                      drop-placeholder="اسحب الملف هنا"
                      browse-text="تصفح"
                      :accept="a.getAcceptExtensions('ملف التصحيح RTK')"
                      class="flex-grow-1 mb-0"
                    />
                    <b-button
                      v-b-tooltip.hover.top="a.getConditionalFile('correction_file_rtk') ? 'تحديث' : 'رفع'"
                      size="sm"
                      variant="primary"
                      class="flex-shrink-0"
                      :disabled="!a.conditionalUploads.correction_file_rtk || a.isUploadingConditional('correction_file_rtk')"
                      @click="a.submitConditionalUpload('correction_file_rtk')"
                    >
                      <b-spinner
                        v-if="a.isUploadingConditional('correction_file_rtk')"
                        small
                      />
                      <feather-icon
                        v-else
                        icon="UploadIcon"
                        size="12"
                      />
                    </b-button>
                  </div>
                </div>
                <!-- Notes Section -->
                <div
                  v-if="a.getConditionalFile('correction_file_rtk')"
                  class="media-card-notes w-100 "
                >
                  <div
                    v-if="!a.editingNotes[a.getConditionalFile('correction_file_rtk').id]"
                    class="notes-display"
                  >
                    <div
                      v-if="a.getConditionalFile('correction_file_rtk').notes"
                      class="notes-content"
                    >
                      <p class="notes-text mb-0">
                        {{ a.getConditionalFile('correction_file_rtk').notes }}
                      </p>
                    </div>
                  </div>
                  <div
                    v-else
                    class="notes-edit"
                  >
                    <b-form-textarea
                      v-model="a.notesEdit[a.getConditionalFile('correction_file_rtk').id]"
                      placeholder="أدخل الملاحظات..."
                      rows="3"
                      class=""
                      :disabled="a.savingNotes[a.getConditionalFile('correction_file_rtk').id]"
                    />
                    <div class="d-flex gap-1">
                      <b-button
                        size="sm"
                        variant="primary"
                        class="flex-fill"
                        :disabled="a.savingNotes[a.getConditionalFile('correction_file_rtk').id]"
                        @click="a.saveNote(a.getConditionalFile('correction_file_rtk'))"
                      >
                        <b-spinner
                          v-if="a.savingNotes[a.getConditionalFile('correction_file_rtk').id]"
                          small
                          class="mr-1"
                        />
                        حفظ
                      </b-button>
                      <b-button
                        size="sm"
                        variant="outline-secondary"
                        class="flex-fill"
                        :disabled="a.savingNotes[a.getConditionalFile('correction_file_rtk').id]"
                        @click="a.cancelEditingNote(a.getConditionalFile('correction_file_rtk').id)"
                      >
                        إلغاء
                      </b-button>
                    </div>
                  </div>
                </div>
                <div
                  v-if="a.getConditionalFile('correction_file_rtk')"
                  class="media-card-actions d-flex flex-row justify-content-center gap-1 w-100 "
                >
                  <b-button
                    v-if="a.getConditionalFile('correction_file_rtk').is_image || a.getConditionalFile('correction_file_rtk').is_video || a.getConditionalFile('correction_file_rtk').is_document"
                    v-b-tooltip.hover.top="'معاينة'"
                    :href="a.getConditionalFile('correction_file_rtk').url"
                    target="_blank"
                    size="sm"
                    variant="info"
                  >
                    <feather-icon icon="EyeIcon" size="12" />
                  </b-button>
                  <b-button
                    v-if="a.hasPermission('download media')"
                    v-b-tooltip.hover.top="'تحميل'"
                    :href="a.getConditionalFile('correction_file_rtk').download_url"
                    target="_blank"
                    size="sm"
                    variant="success"
                  >
                    <feather-icon icon="DownloadIcon" size="12" />
                  </b-button>
                  <b-button
                    v-if="a.hasPermission('delete media')"
                    v-b-tooltip.hover.top="'حذف'"
                    size="sm"
                    variant="danger"
                    @click="a.deleteConditionalFile('correction_file_rtk', a.getConditionalFile('correction_file_rtk').id)"
                  >
                    <feather-icon icon="Trash2Icon" size="12" />
                  </b-button>
                  <b-button
                    v-if="!a.editingNotes[a.getConditionalFile('correction_file_rtk').id] && a.hasPermission('edit projects')"
                    v-b-tooltip.hover.top="a.getConditionalFile('correction_file_rtk').notes ? 'تعديل الملاحظات' : 'إضافة ملاحظات'"
                    size="sm"
                    variant="outline-secondary"
                    @click="a.startEditingNote(a.getConditionalFile('correction_file_rtk'))"
                  >
                    <feather-icon icon="EditIcon" size="12" />
                  </b-button>
                </div>
              </b-card>
            </div>
          </div>

          <!-- Conditional Upload Fields for VRS Full -->
          <!-- v-if="a.hasPermission('Surveyor Custom') || a.hasRole('admin')" -->
          <div class="required-block required-block-raw mb-1 attachments-block-collapse-wrapper">
            
            <b-button
              variant="link"
              @click="a.checkThemAll(6)"
            >  
              <h6 class="required-block-title mb-2">
                <feather-icon
                  :icon="a.show_attachments_block6 ? 'ChevronUpIcon' : 'ChevronDownIcon'"
                  size="16"
                  class="mr-1"
                />
                مجموعة ملفات الرفع المساحي خام من الكنترول
              </h6>
            </b-button>
            <b-collapse v-model="a.show_attachments_block6">

              <div class="d-flex flex-wrap required-block-cards">
                <attachment-media-card
                  v-for="field in a.vrsFullFields"
                  :key="field.key"
                  :title="field.label"
                  :file="a.getConditionalFile(field.key)"
                  :upload-value="a.conditionalUploads[field.key]"
                  upload-layout="inline"
                  :upload-disabled="false"
                  :submit-disabled="a.isRawControlUploadDisabled"
                  :show-team-disabled-message="a.isRawControlUploadDisabled"
                  :team-disabled-text="a.rawControlUploadDisabledHint"
                  :accept="a.getAcceptExtensions(field.label)"
                  :uploading="a.isUploadingConditional(field.key)"
                  card-margin-class="mb-1"
                  :editing-note="a.isFileNoteEditing(a.getConditionalFile(field.key))"
                  :note-draft="a.getFileNoteDraft(a.getConditionalFile(field.key))"
                  :saving-note="a.isFileNoteSaving(a.getConditionalFile(field.key))"
                  @update:upload-value="a.setConditionalUpload(field.key, $event)"
                  @submit-upload="a.submitConditionalUpload(field.key)"
                  @delete="a.deleteConditionalFile(field.key, a.getConditionalFile(field.key).id)"
                  @save-note="a.saveNote(a.getConditionalFile(field.key))"
                  @cancel-edit-note="a.cancelEditingNote(a.getConditionalFile(field.key).id)"
                  @start-edit-note="a.startEditingNote(a.getConditionalFile(field.key))"
                  @update:note-draft="a.setFileNoteDraft(a.getConditionalFile(field.key), $event)"
                />
              </div>
              <!-- JXL Import Button -->
              <div class="w-100 mt-2 mb-2">
                <b-button
                  variant="success"
                  size="sm"
                  :disabled="a.isRawControlUploadDisabled"
                  @click="a.handleJxlImportClick"
                >
                  <feather-icon
                    icon="UploadIcon"
                    size="14"
                    class="mr-1"
                  />
                  استيراد ملف JXL
                </b-button>
                <small
                  v-if="a.project && a.project.has_jxl"
                  class="text-warning d-block mt-1"
                >
                  <feather-icon
                    icon="AlertCircleIcon"
                    size="12"
                    class="mr-1"
                  />
                  المشروع يحتوي بالفعل على ملف JXL
                </small>
              </div>
            </b-collapse>
            <b-button
              class="attachments-block-collapse-toggle-btn"
              variant="light"
              size="sm"
              @click="a.show_attachments_block6 = !a.show_attachments_block6"
              v-b-tooltip.hover.top="a.show_attachments_block6 ? 'إخفاء' : 'إظهار'"
            >
              <feather-icon
                :icon="a.show_attachments_block6 ? 'ChevronUpIcon' : 'ChevronDownIcon'"
                size="16"
                class="mr-25"
              />
            </b-button>
          </div>
          <!-- v-if="a.hasPermission('Surveyor Custom') || a.hasRole('admin')" -->
          <!-- <ProjectNoteEditor
            :project-id="a.projectId"
            group="attachments_raw_control"
            label="ملاحظات ملفات الرفع المساحي الخام من الكنترول"
            class="mb-3"
          /> -->
          <div class="d-flex flex-wrap required-block-cards">
                <attachment-media-card
                  v-for="card in a.requiredCardsBlock1"
                  :key="`required-${card.key}`"
                  :title="card.key"
                  :file="card.file"
                  :upload-value="a.requiredUploads[card.key]"
                  upload-layout="inline"
                  :show-team-disabled-message="a.isUploadDisabledByTeam(card.key)"
                  :accept="a.getAcceptExtensions(card.key)"
                  :upload-disabled="a.isUploadDisabledByTeam(card.key)"
                  :uploading="a.isUploadingRequired(card.key)"
                  :is-cad-ark="card.key === 'ملف CAD من الارك'"
                  card-margin-class="mb-1"
                  notes-section-class=""
                  notes-textarea-class=""
                  :show-collection-checkbox="a.isProject168 && Boolean(card.file)"
                  :collection-selected="Boolean(card.file && a.isCollectionSelected(card.file))"
                  :editing-note="a.isFileNoteEditing(card.file)"
                  :note-draft="a.getFileNoteDraft(card.file)"
                  :saving-note="a.isFileNoteSaving(card.file)"
                  @update:upload-value="a.setRequiredUpload(card.key, $event)"
                  @submit-upload="a.submitRequired(card.key)"
                  @delete="a.deleteFile(card.file.id)"
                  @save-note="a.saveNote(card.file)"
                  @cancel-edit-note="a.cancelEditingNote(card.file.id)"
                  @start-edit-note="a.startEditingNote(card.file)"
                  @update:note-draft="a.setFileNoteDraft(card.file, $event)"
                  @collection-change="a.onCollectionCheckboxChange(card.file, $event)"
                />

          </div>
            <ProjectNoteEditor
            :project-id="a.projectId"
            group="attachments_block1"
            label="ملاحظات مرفقات المساح من الطبيعة"
            class="mb-2"
          />

          <surveyor-acknowledgment-section
            v-if="a.projectId"
            :project-id="a.projectId"
          />
          <giser-acknowledgment-section
            v-if="a.projectId"
            :project-id="a.projectId"
          />
        </div>
</template>

<script>
import attachmentsBlockMixin from '../attachmentsBlockMixin'
import { ATTACHMENT_BLOCK_KEYS } from '../attachmentsBlockLoader'
import SurveyorAcknowledgmentSection from '../../surveyor/SurveyorAcknowledgmentSection.vue'
import GiserAcknowledgmentSection from '../../giser/GiserAcknowledgmentSection.vue'
import SurveyMethodSelector from '@/views/modules/projects/SurveyMethodSelector.vue'

export default {
  name: 'AttachmentsBlock1',
  mixins: [attachmentsBlockMixin],
  components: {
    SurveyorAcknowledgmentSection,
    GiserAcknowledgmentSection,
    SurveyMethodSelector,
  },
  mounted() {
    if (this.a) {
      this.a.ensureBlockDataLoaded(ATTACHMENT_BLOCK_KEYS.BLOCK1)
    }
  },
}
</script>

<style src="../attachments-shared.scss" lang="scss"></style>
